import React, { useState } from 'react';
import { UsersIcon, PercentIcon, BarChart3Icon, BrainIcon } from 'lucide-react';
const SimilarPlayers = () => {
  const [activeTab, setActiveTab] = useState('similar');
  const [mode, setMode] = useState<'stats' | 'neuro'>('stats');
  const similarPlayers = [{
    name: 'Marcus Thompson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628369.png',
    similarity: 92
  }, {
    name: 'David Williams',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629029.png',
    similarity: 85
  }, {
    name: 'Chris Anderson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629027.png',
    similarity: 78
  }, {
    name: 'Kevin Mitchell',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628371.png',
    similarity: 75
  }, {
    name: 'Robert Johnson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629028.png',
    similarity: 73
  }];
  const compatiblePlayers = [{
    name: 'Michael Roberts',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630173.png',
    compatibility: 95
  }, {
    name: 'James Wilson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630170.png',
    compatibility: 88
  }, {
    name: 'Anthony Davis Jr',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628389.png',
    compatibility: 82
  }, {
    name: 'Thomas Brown',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630174.png',
    compatibility: 79
  }, {
    name: 'Stephen White',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630175.png',
    compatibility: 76
  }];
  const neuroSimilarPlayers = [{
    name: 'Chris Anderson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629027.png',
    similarity: 89,
    archetype: 'Commander'
  }, {
    name: 'Robert Johnson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629028.png',
    similarity: 84,
    archetype: 'Commander'
  }, {
    name: 'Marcus Thompson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628369.png',
    similarity: 79,
    archetype: 'Strategist'
  }, {
    name: 'Kevin Mitchell',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628371.png',
    similarity: 74,
    archetype: 'Reactor'
  }, {
    name: 'David Williams',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629029.png',
    similarity: 71,
    archetype: 'Strategist'
  }];
  const neuroCompatiblePlayers = [{
    name: 'James Wilson',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630170.png',
    compatibility: 93,
    archetype: 'Catalyst'
  }, {
    name: 'Thomas Brown',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630174.png',
    compatibility: 87,
    archetype: 'Anchor'
  }, {
    name: 'Michael Roberts',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630173.png',
    compatibility: 81,
    archetype: 'Reactor'
  }, {
    name: 'Stephen White',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1630175.png',
    compatibility: 78,
    archetype: 'Catalyst'
  }, {
    name: 'Anthony Davis Jr',
    photo: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628389.png',
    compatibility: 74,
    archetype: 'Anchor'
  }];
  const getColorClass = (value: number) => {
    if (value >= 90) return 'text-green-600';
    if (value >= 80) return 'text-green-500';
    if (value >= 70) return 'text-yellow-500';
    return 'text-orange-500';
  };
  const currentSimilar = mode === 'stats' ? similarPlayers : neuroSimilarPlayers;
  const currentCompatible = mode === 'stats' ? compatiblePlayers : neuroCompatiblePlayers;
  return <div className="bg-white rounded-lg shadow-md h-full w-64 flex-shrink-0" data-id="element-1001" data-mp="2pa13btmk35d3">
      {/* Similar / Compatible Tabs */}
      <div className="flex border-b" data-id="element-1002" data-mp="36zwgiex9go5w">
        <button onClick={() => setActiveTab('similar')} className={`flex-1 flex justify-center items-center py-3 ${activeTab === 'similar' ? 'border-b-2 border-blue-600' : ''}`} data-id="element-1003" data-mp="370xsclm3peoo">
          <UsersIcon className="w-5 h-5" data-id="element-1004" data-mp="3grk3a2ivhh11" />
        </button>
        <button onClick={() => setActiveTab('compatible')} className={`flex-1 flex justify-center items-center py-3 ${activeTab === 'compatible' ? 'border-b-2 border-blue-600' : ''}`} data-id="element-1005" data-mp="3lplk0gstt49c">
          <PercentIcon className="w-5 h-5" data-id="element-1006" data-mp="3upgyauhohfdl" />
        </button>
      </div>

      {/* Mode Toggle */}
      <div className="px-4 pt-3 pb-2" data-id="element-1007" data-mp="3jpai1rdiety">
        <div className="flex items-center bg-gray-100 rounded-lg p-0.5" data-id="element-1008" data-mp="3inz1w6g3qbp">
          <button onClick={() => setMode('stats')} className={`flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-md text-[11px] font-bold transition-colors ${mode === 'stats' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-1009" data-mp="20d0x483qorfl">
            <BarChart3Icon className="w-3.5 h-3.5" data-id="element-1010" data-mp="1szt3qyhalj17" />
            STATS
          </button>
          <button onClick={() => setMode('neuro')} className={`flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-md text-[11px] font-bold transition-colors ${mode === 'neuro' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-1011" data-mp="1o2jbzc6fkva7">
            <BrainIcon className="w-3.5 h-3.5" data-id="element-1012" data-mp="2bsdrk1i4wxy5" />
            NEURO
          </button>
        </div>
      </div>

      <div className="p-4" data-id="element-1013" data-mp="26qekohn6riwg">
        {activeTab === 'similar' ? <>
            {currentSimilar.map((player: any, index: number) => <div key={index} className="mb-4" data-id="element-1014" data-mp="vckmxgs8ky5j" data-mpi={index}>
                <div className="flex items-start space-x-3" data-id="element-1015" data-mp="vedsstv0zech">
                  <div className="flex-shrink-0" data-id="element-1016" data-mp="qd7wkm25p8y7">
                    <div className="w-16 h-16 overflow-hidden rounded-md" data-id="element-1017" data-mp="qfu6gscis0jl">
                      <img src={player.photo} alt={player.name} className="w-full h-full object-cover" data-id="element-1018" data-mp="3ekznv5fmxhvz" />
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-1019" data-mp="39klg7ohy49yh">
                    <div className="font-bold text-sm" data-id="element-1020" data-mp="39jadzt45fa9h">{player.name}</div>
                    <div className={`text-sm font-semibold ${getColorClass(player.similarity)}`} data-id="element-1021" data-mp="2uv5rsf5w0gly">
                      {player.similarity}%
                    </div>
                    {mode === 'stats' ? <div className="mt-1 grid grid-cols-2 gap-2 text-xs text-gray-600" data-id="element-1022" data-mp="2lswj7uu6ixb7">
                        <div data-id="element-1023" data-mp="2quc5trc09bvp">PPG: 24.5</div>
                        <div data-id="element-1024" data-mp="2bx36obggn3tf">RPG: 6.2</div>
                        <div data-id="element-1025" data-mp="2bxd24ek9y36i">APG: 7.1</div>
                        <div data-id="element-1026" data-mp="2gvwmiaj7z6wr">FG%: 48.2</div>
                      </div> : <div className="mt-1" data-id="element-1027" data-mp="1xa4m90g0t9o7">
                        <div className="text-[10px] text-indigo-600 font-semibold bg-indigo-50 px-1.5 py-0.5 rounded inline-block" data-id="element-1028" data-mp="1xaw5dbsflexl">
                          {player.archetype}
                        </div>
                      </div>}
                  </div>
                </div>
              </div>)}
            <button className="w-full bg-gray-900 text-white py-2 text-sm rounded-md mt-2" data-id="element-1029" data-mp="22bagj2pbx4zu">
              see more
            </button>
          </> : <>
            {currentCompatible.map((player: any, index: number) => <div key={index} className="mb-4" data-id="element-1030" data-mp="2pz1q3yjhj3xf" data-mpi={index}>
                <div className="flex items-start space-x-3" data-id="element-1031" data-mp="2q0wbfdyo4y21">
                  <div className="flex-shrink-0" data-id="element-1032" data-mp="2l0qhts8u91hb">
                    <div className="w-16 h-16 overflow-hidden rounded-md" data-id="element-1033" data-mp="2l21mrve0sfa0">
                      <img src={player.photo} alt={player.name} className="w-full h-full object-cover" data-id="element-1034" data-mp="2zx7qgbpn8206" />
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-1035" data-mp="1kk41cf9mdbz5">
                    <div className="font-bold text-sm" data-id="element-1036" data-mp="1kj2hblamlf5a">{player.name}</div>
                    <div className={`text-sm font-semibold ${getColorClass(player.compatibility)}`} data-id="element-1037" data-mp="1pkrtj49l3yuy">
                      {player.compatibility}%
                    </div>
                    {mode === 'stats' ? <div className="mt-1 grid grid-cols-2 gap-2 text-xs text-gray-600" data-id="element-1038" data-mp="11u5kparraajw">
                        <div data-id="element-1039" data-mp="11rt2cwi35y6b">PPG: 22.8</div>
                        <div data-id="element-1040" data-mp="16s7dinezho8k">RPG: 5.9</div>
                        <div data-id="element-1041" data-mp="16r5qrlolvdb0">APG: 6.8</div>
                        <div data-id="element-1042" data-mp="1bk78e1g75qya">FG%: 46.5</div>
                      </div> : <div className="mt-1" data-id="element-1043" data-mp="e531hyhh49na">
                        <div className="text-[10px] text-indigo-600 font-semibold bg-indigo-50 px-1.5 py-0.5 rounded inline-block" data-id="element-1044" data-mp="e4b90wj6as18">
                          {player.archetype}
                        </div>
                      </div>}
                  </div>
                </div>
              </div>)}
            <button className="w-full bg-gray-900 text-white py-2 text-sm rounded-md mt-2" data-id="element-1045" data-mp="2nd9cus5dy67b">
              see more
            </button>
          </>}
      </div>
    </div>;
};
export default SimilarPlayers;